import React from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import {
  Breadcrumbs as MuiBreadcrumbs,
  Link,
  Typography,
  Box,
} from "@mui/material";
import { NavigateNext as NavigateNextIcon } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { selectSelectedCustomer } from "../feature/customer/customerSlice";
import { selectSelectedSite } from "../feature/site/siteSlice";
import { selectSelectedUser } from "../feature/user/userSlice";
import { selectSelectedOrder } from "../feature/orders/orderSlice";

const Breadcrumbs: React.FC = () => {
  const location = useLocation();
  const state = location.state as Record<string, any> | undefined;
  const pathnames = location.pathname.split("/").filter((x) => x);

  const dispatch = useDispatch();

  const selectedCustomer = useSelector(selectSelectedCustomer);
  const selectedOrders = useSelector(selectSelectedOrder);
  const selectedsite = useSelector(selectSelectedSite);
  const selectedUser = useSelector(selectSelectedUser);

  useEffect(()=>{
    console.log("Current selectedCustomer===>:", selectedCustomer);
    console.log("Current selectedOrders===>:", selectedOrders);
    console.log("Current selectedsite===>:", selectedsite);
    console.log("Current selectedUser===>:", selectedUser);
  },[selectedCustomer,selectedOrders,selectedsite,selectedUser])

  console.log("Current pathnames:", pathnames);

  const reportNames: Record<string, string> = {
    "order-status": "Order Status Report",
    "comprehensive-order-tracking": "Comprehensive Order Tracking",
    "work-order-by-item": "Work Order by Items",
    "employee-staff-work-summary": "Employee Staff Work Summary",
    "work-order-frames": "Work Order Only Frames",
    "employee-monthly": "Employee Monthly Report",
    "employee-yearly": "Employee Yearly Report",
  };

  return (
    <Box sx={{ pl: { xs: 1, sm: 2 } }}>
      <MuiBreadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
        className="text-primary-600 dark:text-primary-400"
        sx={{
          "& .MuiBreadcrumbs-separator": {
            mx: 1,
          },
          "& .MuiBreadcrumbs-li": {
            display: "flex",
            alignItems: "center",
          },
        }}
      >
        <Link
          component={RouterLink}
          to="/"
          color="inherit"
          sx={{
            textDecoration: "none",
            "&:hover": {
              textDecoration: "underline",
            },
          }}
        >
          Home
        </Link>
        {pathnames.map((name, index) => {
          const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`;
          const isLast = index === pathnames.length - 1;

          const formattedName = name
            .split("-")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");

          //  Default formatting
          let displayName = name
            .split("-")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");

          // Override with actual entity names based on current path segment
          if (name === "customers" && selectedCustomer && !isLast) {
            // For customer list pages, show "Customers"
            displayName = "Customers";
          } else if (name === "orders" && selectedOrders && !isLast) {
            // For order list pages, show "Order"
            displayName = "Work Orders";
          } else if (name === "stage-status" ) {
            // For order list pages, show "Order"
            displayName = "Work Status";
          } else if (name === "sites" && selectedsite && !isLast) {
            // For site list pages, show "Sites"
            displayName = "Sites";
          } else if (name === "users" && selectedUser && !isLast) {
            // For user list pages, show "Users"
            displayName = "Users";
          } else if (pathnames.includes("customers") && selectedCustomer && isLast) {
            // For customer detail pages, show customer name (handle nested structure)
            displayName = selectedCustomer.name || selectedCustomer?.customer?.name || "";
          } else if (pathnames.includes("orders") && selectedOrders && isLast) {
            // For order detail pages, show order number or customer name
            displayName = selectedOrders.orderNumberNew || selectedOrders.orderNumberNew || selectedOrders?.customer?.name || "";
          } else if (pathnames.includes("sites") && selectedsite && isLast) {
            // For site detail pages, show site name
            displayName = selectedsite?.name || selectedsite?.[0]?.name || "";
          } else if (pathnames.includes("users") && selectedUser && isLast) {
            // For user detail pages, show user name
            displayName = `${selectedUser.firstName} ${selectedUser.lastName}`.trim() || selectedUser.username || selectedUser.email;
          }else if (pathnames[0] === "reports") {
            if (index === 0) {
              displayName = "Report Menu";
            } else if (index === 1 && reportNames[name]) {
              displayName = reportNames[name];
            }
          }

          return false ? (
            <Typography
              key={name}
              // color="text.primary"
              className="text-primary-600 dark:text-primary-400"
              sx={{ fontWeight: "medium" }}
            >
              {displayName}
            </Typography>
          ) : (
            <Link
              key={name}
              component={RouterLink}
              to={routeTo}
              color="inherit"
              sx={{
                textDecoration: "none",
                "&:hover": {
                  textDecoration: "underline",
                },
              }}
            >
              {displayName}
            </Link>
          );
        })}
      </MuiBreadcrumbs>
    </Box>
  );
};

export default Breadcrumbs;
